/* MENU */
export const GET_CATALOGS_MENU = "GET_CATALOGS_MENU"
export const GET_CATALOGS_MENU_SUCCESS = "GET_CATALOGS_MENU_SUCCESS"
export const GET_CATALOGS_MENU_FAIL = "GET_CATALOGS_MENU_FAIL"

/* SET STATE */
export const SET_STATE_MENUCATALOGS = "SET_STATE_MENUCATALOGS"